import React from "react";
import * as DIAG from "storm-react-diagrams";
import NodeView from "./NodeView";

export default class NodeFactory extends DIAG.NodeWidgetFactory {
    /**
	 * Normal node factory
	 * @module NodeFactory
     */
	constructor() {
		super("default");
	}

    /**
	 * Generator
     * @param diagramEngine DiagramEngine instance of current diagram
     * @param node Node model
     * @returns {Object} React element
     */
	generateReactWidget(diagramEngine, node) {
		return React.createElement(NodeView, {
			node: node,
			diagramEngine: diagramEngine
		});
	}
}
